import {generateCrash} from '~/modules/logging';
import {useAuth} from '~/store/hooks';

export function DevStuff() {
  const {userId} = useAuth();

  return (
    <div className="p-6">
      <button className="btn btn-primary" onClick={generateCrash}>
        Raise Error
      </button>
      <div className="py-4">
        <p>User ID: {userId}</p>
      </div>
    </div>
  );
}
